<span
  [ngClass]="status() | userStatusCss | async"
  class="inline-flex items-center rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset">
  {{ status() | userStatusLabel | async }}
</span>
